// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 624 ? "af015fe3" : chunkId) + "." + {"624":"1f16b62365915ec2","1140":"8299078f9437c88c","1364":"0e330d8acf4f1ce5","2261":"2b717d5e6c979343","3966":"9f15740b46c45b53","4650":"a2355b65432e262d","7597":"03e06203902be13b","7824":"91946ec56a2da54e","7919":"d0616dd4a2a21565"}[chunkId] + ".js";
};